import type { ChangeEvent } from 'react';
import { useState } from 'react';

export function useSearchFilter<T extends string>(initialType: T) {
  const [query, setQuery] = useState('');
  const [searchType, setSearchType] = useState<T>(initialType);
  const [page, setPage] = useState(0);

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
    setPage(0);
  };

  const handleSearchTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const type = event.target.value as T;
    setSearchType(type);
    setPage(0);
  };

  return {
    query,
    setQuery,
    searchType,
    setSearchType,
    page,
    setPage,
    handleSearch,
    handleSearchTypeChange,
  };
}
